export default {
  primary: '#45606b',
  grey4: '#8c8c8c',
  success: '#52c41a',
};
